import jwtAuthAxios from "./auth/jwtAuth";

const logsServices = {};

logsServices.getLogs = async (params) => {
    const {data} = await jwtAuthAxios.get(`/logs${params}`);
    return data;
};

export default logsServices;